<div class="video-preview" [class.round]="msg.type === types.VideoNote">

  @if (msg.source === 'web' || file.size <= 20 * 1024 * 1024) {
    @if (file.posterUrl) {
      <img src="{{file.posterUrl}}" class="poster">
    }
    <!--    <video-->
    <!--      mat-card-image-->
    <!--      [src]="fileUrl"-->
    <!--      preload="metadata"-->
    <!--      [poster]="file.video.poster"-->
    <!--      *ngIf="file.video.poster"-->
  <!--    ></video>-->
  @if (!file.posterUrl) {
    <video mat-card-image [src]="file.publicUrl" preload="metadata"></video>
  }
  <a [href]="file.publicUrl" target="_blank">
    <mat-icon class="play-mark">play_circle_outline</mat-icon>
  </a>
}
@if (msg.source === 'bot' && file.size >= 20 * 1024 * 1024) {
  <h2 i18n="Post message item|error @@postMessageItem.largeFileError">Файл слишком большой</h2>
}
</div>
